module.exports = __webpack_public_path__ + "img/personal_icon.a0501dfd.png";